/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import LabelsApi from '../../../../services/api/LabelsApi';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import validationSchema from '../validationSchema';
import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';

export default function LabelEdit(): JSX.Element {
  const { id } = useParams();
  const [itemData, setItemData] = useState({
    width: '',
    height: '',
    dataArrived: false,
  });
  const history = useHistory();

  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    let res = null;
    if (id) {
      res = await LabelsApi.update(id, values);
    } else {
      res = await LabelsApi.create(values);
    }
    if (res.status === StatusCodes.OK) {
      history.push('/labels');
    } else {
      setSubmitting(false);
    }
  };

  const getItem = async () => {
    const res = await LabelsApi.get(id);
    const newItemData = { ...res.data, dataArrived: true };
    setItemData(newItemData);
  };

  useEffect(() => {
    if (id) {
      getItem(id);
    }
  }, []);

  return (
    <>
      <WhitePad>
        <TitleComponent
          onLeftHandler={() => {
            history.goBack();
          }}
          title={`${id ? 'Edit ' : 'Create '}Label`}
        />
        <FormWrapper style={{ dispaly: 'flex', flexDirection: 'column' }}>
          {id && itemData.dataArrived === false ? null : (
            <Formik
              initialValues={{
                width: itemData.width,
                height: itemData.height,
              }}
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                saveItem(values, setSubmitting);
              }}
            >
              {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                <form onSubmit={handleSubmit} autoComplete="off">
                  <FormRow>
                    <TextInputComponent
                      name="width"
                      label="Width (cm)"
                      value={values.width}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={12}
                      type="number"
                    />
                  </FormRow>
                  <FormRow>
                    <TextInputComponent
                      name="height"
                      label="Height  (cm)"
                      value={values.height}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={12}
                      type="number"
                    />
                  </FormRow>
                  <PrimaryButton isSubmitting={isSubmitting} type="submit" title="Save" />
                </form>
              )}
            </Formik>
          )}
        </FormWrapper>
      </WhitePad>
    </>
  );
}
